export const actions = {
  id: "actions",
  sort: false,
  center: true,
  padding: true,
  label: "Actions"
}
